export default "__VITE_ASSET___045iVlY__"